import { useLocation } from "react-router-dom";

import { useFeatureFlagContext } from "../../../hooks/useFeatureFlagContext";

export type HeaderVariant = "v1" | "v2";

export type HeaderFlags = {
  variant: HeaderVariant;
  forceIpad: boolean;
};

export const useHeaderFlags = (): HeaderFlags => {
  const { search } = useLocation();
  const { isFlagEnabled } = useFeatureFlagContext();

  const params = new URLSearchParams(search);
  const urlVariant = params.get("header");
  const flagEnabled = isFlagEnabled("alphaHeader");

  const variant: HeaderVariant =
    urlVariant === "v2" || (urlVariant !== "v1" && flagEnabled) ? "v2" : "v1";
  const forceIpad = params.get("force") === "ipad";

  return { variant, forceIpad };
};
